import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import Block from "../../Block/Block";
import BlockVideo from "../../Block/BlockVideo";

function ImmerseDecorVR() {
    return (
        <div>
        <Header/>        

        <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                    height:"200px",
                    width: "100%",
                    backgroundSize: "100% 100%",
                    backgroundPosition: "bottom"}}>
        </div>

        <Block colorTheme="light" gridTemplateColumns="600px 600px">
            <BlockContent>
            <BlockTitle>Artec Ray Visualizer</BlockTitle>
            </BlockContent>
            <BlockContent>
            <BlockText>This tool provides interactive visualization for 3D point cloud data captured with the Artec Ray scanner. In addition to the geometry, it supports the display of supplementary scene information such as semantic labels and depth maps.</BlockText>
            </BlockContent>
        </Block>

        <Block gridTemplateColumns="900px 300px">
            <BlockContent>
            <BlockText>
                This visualizer supports loading and exploring point cloud data acquired with the Artec Ray scanner (Figure 1). The device is a stationary, long-range LiDAR system designed for capturing large-scale objects and environments at distances of up to 110 m. It provides a 360° horizontal and 270° vertical field of view with a ranging accuracy of approximately 0.7 mm at 15 m. In addition to geometric data, the scanner records RGB texture information using two integrated 5 MP cameras, enabling colorized point clouds. Prior to visualization, the raw scans are processed in Artec Studio to generate a compatible and structured dataset.
            </BlockText>
            </BlockContent>
            <BlockContent>
                <BlockImage src={process.env.PUBLIC_URL + '/images/projects/ArtecRay.webp'} shadow={false} title="Figure 1: Artec Ray Scanner"/>
            </BlockContent>
        </Block>

        <Block gridTemplateColumns="1200px">
            <BlockContent>
                <BlockText>
                    This tool was primarily developed to visualize interior 3D reconstructions of buildings at the Ernst-Abbe-Hochschule Jena (University of Applied Sciences Jena). Figure 2 shows a reconstruction of the building's exterior, which forms part of our EAH dataset. The extent of the captured indoor areas is illustrated in Videos 1 and 2. Both videos present post-processed 3D reconstructions, where the point clouds have been registered and converted into meshes.
                </BlockText>
            </BlockContent>
        </Block>

        <Block gridTemplateColumns="300px 300px 300px 300px">
            <BlockContent>
                <BlockImage src={process.env.PUBLIC_URL + '/images/projects/EAH123.webp'} title="Figure 2: 3D reconstruction of the façade of the Ernst-Abbe-Hochschule Jena building."/>
            </BlockContent>
            <BlockContent>
                <BlockVideo src="https://potechius.com/Videos/XRayEAH.mp4" title="Video 1: Interior 3D reconstruction of the Ernst-Abbe-Hochschule Jena."/>
            </BlockContent>
            <BlockContent>
                <BlockVideo src="https://potechius.com/Videos/XRayEAH2.mp4" title="Video 2: Walkthrough of the 3D Reconstructions"/>
            </BlockContent>
            <BlockContent>
                <BlockVideo src="https://potechius.com/Videos/R38.mp4" title="Video 3: Textured 3D reconstruction of a seminar room"/>
            </BlockContent>
        </Block>




        <Block gridTemplateColumns="600px 600px">
            <BlockContent>
                <BlockImage src={process.env.PUBLIC_URL + '/images/projects/RayPlan.webp'} title="Figure 3: Ray Visualizer Interface"/>
            </BlockContent>
            <BlockContent>
                <BlockText>
                    Figure 3 shows the interface of the visualizer. For each reconstruction, a floor plan is provided indicating the scanner positions corresponding to the 3D point clouds displayed on the left. In addition, the images used for colorizing the point cloud can be inspected. The tool further supports supplementary modalities, including semantic maps, depth maps, normal maps, and validity masks derived from the raw data. While depth, normal, and validity maps are computed automatically, the semantic and instance annotations are created manually. A demonstration of the tool is provided in Video 3.
                </BlockText>
            </BlockContent>
        </Block>


        <Block gridTemplateColumns="1200px">
            <BlockContent>
                <BlockVideo src="https://potechius.com/Videos/RayViz.mp4" title="Video 3: Demonstration of the Ray Visualizer"/>
            </BlockContent>
        </Block>

        <Footer/>
        </div>
    );
}

export default ImmerseDecorVR;